import moment from 'moment';
const randomIdMaxSize = 10000;

export function generateRandomId() {
  return `${Math.floor((Math.random() + 1) * randomIdMaxSize)}${moment().format('x')}`;
}

export const calculateVariation = (previous, current) => {
  if (!previous) {
    return;
  }

  return (current - previous) / Math.abs(previous) * 100;
};
